import React from "react";

import { Box, Card, CardContent, Divider, Stack, Typography } from "@mui/material";

import { Client, User, UserType } from "../../../types";
import ClientChip from "../../../components/chips/client-chip";
import RoleChip, { type RoleChipValue } from "../../../components/chips/role-chip";

interface ClientsCardProps {
  user: User;
  clients: (Client | null)[];
}

const getClientRoleChipValue = (user: User): RoleChipValue => {
  if (user.userType === UserType.DeveloperAdmin) return "Developer Admin";
  if (user.userType === UserType.SysAdmin) return "Client Admin";
  if (user.userType === UserType.OrgAdmin) return "Team Admin";
  if (user.userType === UserType.Guest) return "Guest";
  if (user.userType === UserType.Blocked) return "Blocked";
  if (user.userType === UserType.Inactive) return "Past Member";

  return "Member";
};

const ClientsCard: React.FC<ClientsCardProps> = ({ user, clients }) => {
  const roleChipValue = getClientRoleChipValue(user);

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h4">Clients</Typography>
          <Divider />

          {clients.length > 0 ? (
            <Stack spacing={1.5}>
              {clients.map((client) =>
                client ? (
                  <Box
                    key={client.clientId}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                    }}
                  >
                    <ClientChip clientId={client.clientId} name={client.clientName} />
                    <RoleChip role={roleChipValue} />
                  </Box>
                ) : null,
              )}
            </Stack>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No clients available
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ClientsCard;